export const AI_TYPES = ["application/pdf", "image/png", "image/jpeg", "image/webp"];

export const DOC_STATUS = {
  UPLOADED: { label: "Caricato", cls: "bg-slate-100 text-slate-700" },
  PROCESSING: { label: "In analisi…", cls: "bg-sky-100 text-sky-800" },
  CLASSIFIED: { label: "Classificato", cls: "bg-indigo-100 text-indigo-800" },
  EXTRACTION_COMPLETE: { label: "Dati estratti", cls: "bg-amber-100 text-amber-800" },
  TO_REVIEW: { label: "Da verificare", cls: "bg-amber-100 text-amber-800" },
  VERIFIED: { label: "Verificato", cls: "bg-green-100 text-green-800" },
  REJECTED: { label: "Rifiutato", cls: "bg-slate-200 text-slate-600" },
  SUPERSEDED: { label: "Sostituito", cls: "bg-slate-200 text-slate-500" },
  ARCHIVED: { label: "Archiviato", cls: "bg-slate-200 text-slate-500" },
  PROCESSING_ERROR: { label: "Errore lettura", cls: "bg-red-100 text-red-700" },
};

export const FIELD_STATUS = {
  PROPOSED: { label: "Da confermare", cls: "bg-amber-100 text-amber-800" },
  ACCEPTED: { label: "Confermato", cls: "bg-green-100 text-green-800" },
  CORRECTED: { label: "Corretto", cls: "bg-sky-100 text-sky-800" },
  REJECTED: { label: "Non corretto", cls: "bg-slate-200 text-slate-600" },
  TO_VERIFY: { label: "Da verificare", cls: "bg-amber-100 text-amber-800" },
  CONFLICT: { label: "In conflitto", cls: "bg-red-100 text-red-700" },
};

export const CONFIDENCE_LABEL = { HIGH: "Alta", MEDIUM: "Media", LOW: "Bassa" };

export const REQUEST_STATUS = {
  OPEN: { label: "Da caricare", cls: "bg-amber-100 text-amber-800" },
  UPLOADED: { label: "Caricato", cls: "bg-sky-100 text-sky-800" },
  UNDER_REVIEW: { label: "In verifica", cls: "bg-indigo-100 text-indigo-800" },
  ACCEPTED: { label: "Accettato", cls: "bg-green-100 text-green-800" },
  REJECTED: { label: "Rifiutato", cls: "bg-red-100 text-red-700" },
  WAIVED: { label: "Annullato", cls: "bg-slate-200 text-slate-500" },
};

export function fmtSize(bytes) {
  if (!bytes && bytes !== 0) return "—";
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function fmtFieldValue(f) {
  const v = f.corrected_value ?? f.normalized_value;
  if (v === null || v === undefined) return "—";
  if (typeof v === "boolean") return v ? "Sì" : "No";
  return `${v}${f.unit ? ` ${f.unit}` : ""}${f.currency ? ` ${f.currency}` : ""}`;
}
